export default __webpack_public_path__ + "static/media/rybelsus.4058c4c8.png";